import { render } from "./UserEmailConfirmation.vue?vue&type=template&id=70a67c0a&scoped=true"
import script from "./UserEmailConfirmation.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserEmailConfirmation.vue?vue&type=script&charset=utf-8&lang=js"

import "./UserEmailConfirmation.vue?vue&type=style&index=0&id=70a67c0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a67c0a"]])

export default __exports__